import {Grid, Theme, Typography} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import React from 'react';
import {T} from 'react-polyglot-hooks';
import PriorityLogs from './PriorityLogs';
import RoomPartyMaxOccupancy from './RoomPartyMaxOccupancy';
import GroupMembersNoRoom from './GroupMemberNoRoom';
import RoomPartyNoPrimaryOccupant from './RoomPartyNoPrimaryOccupant';
import OverdueDocuments from './OverdueDocuments';
import UnbalancedPayments from './UnbalancedPayments';
import MyStay from './MyStay';
import {checkRole} from '../../components/Can/Can';
import HowToUseSite from './HowToUseSite';
import OverpaidBillingParties from "./OverpaidBillingParties";

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(2),
        },
        [theme.breakpoints.up('md')]: {
            padding: theme.spacing(4),
        },
    }
}));

const Dashboard = () => {
  const classes = useStyles();
    //
    // const userData = getMe();
    // const loggedIn = !!(userData.data && userData.data.me);
    // const user = userData.data!.me;
    const isSuperAdmin = checkRole(['super-admin']);
    const isAdmin = checkRole(['super-admin', 'admin']);
    const isGroupLeader = checkRole(['group-leader']);
    const isPayingUser = checkRole(['paying-user']);


  return (
    <div className={classes.root}>
      <Grid container spacing={4}>
        <Grid item lg={12} md={12} xl={12} xs={12}>
          <Typography variant="h1">
            <T phrase="Welcome to the WCV Portal" />
          </Typography>
        </Grid>

          {isSuperAdmin && (
              <Grid item xs={12}>
                  <PriorityLogs/>
              </Grid>
          )}

          {!isAdmin && !isPayingUser && (
              <Grid item xs={12}>
                  <HowToUseSite/>
              </Grid>
          )}

          {isAdmin && (
              <React.Fragment>
                  <Grid item xs={12}>
                      <RoomPartyMaxOccupancy/>
                  </Grid>
                  <Grid item xs={12}>
                    <RoomPartyNoPrimaryOccupant/>
                  </Grid>
                  <Grid item xs={12}>
                    <GroupMembersNoRoom/>
                  </Grid>
                  {/*<Grid item xs={12}>*/}
                  {/*  <CancelledGroupMemberPayments/>*/}
                  {/*</Grid>*/}
                  <Grid item xs={12}>
                    <UnbalancedPayments/>
                  </Grid>
                  <Grid item md={12} xs={12}>
                    <OverdueDocuments/>
                  </Grid>
                  <Grid item md={12} xs={12}>
                    <OverpaidBillingParties />
                  </Grid>
              </React.Fragment>
          )}


          {isGroupLeader && (
              <Grid item md={12} xs={12}>
                  {/*<GroupMemberChanges/>*/}
              </Grid>
          )}

          {!isAdmin && isPayingUser && (
              <Grid item xs={12}>
                  <MyStay isAdmin={false} />
              </Grid>
          )}
      </Grid>
    </div>
  );
};

export default Dashboard;
